<template>

<div class="login" :class="{'is-loading': is.loading}">

	<h1><span>rbc</span>guide</h1>

	<p class="login-info">We emailed you a verification code. Enter it below to finish signing in.</p>

	<input ref="code" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="6" v-model="model.code" class="login-text" placeholder="6-digit code" v-on:keypress.enter="onSubmit" />

	<p class="login-error" v-if="is.error">That code didn't match. Please try again.</p>
	<p class="login-info" v-if="is.resent">A new code is on the way.</p>

	<button class="login-button" :disabled="!isValid" :class="{'is-invalid': !isValid}" v-on:click="onSubmit" v-on:submit="onSubmit">
		<template v-if="!is.loading">Verify</template>
		<app-icon icon="loading" v-if="is.loading" />
	</button>

	<a class="login-resend" v-on:click="onResend" :class="{'is-disabled': resendCooldown > 0 || is.resending}">
		<template v-if="is.resending">Sending&hellip;</template>
		<template v-else-if="resendCooldown > 0">Resend code in {{ resendCooldown }}s</template>
		<template v-else>Resend code</template>
	</a>

	<a class="login-back" v-on:click="onBack">Back to login</a>

</div>

</template>

<script>

export default {

	data: function() {

		return {
			is: {
				loading: false,
				error: false,
				resending: false,
				resent: false
			},
			model: {
				code: ''
			},
			resendCooldown: 0,
			cooldownTimer: null
		}

	},

	computed: {

		methodId: function() {

			return this.$store.getters['methodId']

		},

		isValid: function() {

			return /^\d{6}$/.test(this.model.code)

		}

	},

	mounted: function() {

		if (!this.methodId) {

			this.$router.push({ name: 'Login' })
			return

		}

		this.$refs.code.focus()

	},

	beforeDestroy: function() {

		if (this.cooldownTimer) clearInterval(this.cooldownTimer)

	},

	methods: {

		startCooldown: function() {

			this.resendCooldown = 30

			if (this.cooldownTimer) clearInterval(this.cooldownTimer)

			this.cooldownTimer = setInterval(function() {

				this.resendCooldown -= 1

				if (this.resendCooldown <= 0) {

					clearInterval(this.cooldownTimer)
					this.cooldownTimer = null

				}

			}.bind(this), 1000)

		},

		onResend: function() {

			if (this.resendCooldown > 0 || this.is.resending) return

			this.is.resending = true
			this.is.error = false
			this.is.resent = false

			this.$store.dispatch('resend', {
				method_id: this.methodId
			}).then(function() {

				this.is.resending = false
				this.is.resent = true
				this.model.code = ''
				this.startCooldown()
				this.$refs.code.focus()

			}.bind(this), function() {

				this.is.resending = false

			}.bind(this))

		},

		onSubmit: function() {

			if (!this.isValid) return

			this.is.loading = true
			this.is.error = false

			this.$store.dispatch('verify', {
				method_id: this.methodId,
				code: this.model.code
			}).then(function() {

				this.$router.push({ name: 'Dashboard' })

			}.bind(this), function() {

				this.is.loading = false
				this.is.error = true

			}.bind(this))

		},

		onBack: function() {

			this.$store.commit('methodId', false)
			this.$router.push({ name: 'Login' })

		}

	}

}

</script>

<style scoped>

.login {
	width: 320px;
}

.login.is-loading {
	pointer-events: none;
}

.login h1 {
	font-size: 48px;
	font-weight: 300;
	color: #fff;
	text-align: center;
	color: rgba(255, 255, 255, 0.8);
	margin-bottom: 20px;
}

.login h1 span {
	color: #fff;
	font-weight: 400;
}

.login-info {
	color: rgba(255, 255, 255, 0.9);
	text-align: center;
	font-size: 14px;
	margin-bottom: 12px;
}

.login-error {
	color: #ffd6d6;
	text-align: center;
	font-size: 13px;
	margin-top: 6px;
}

.login-text {
	border: 2px solid #fff;
	height: 40px;
	border-radius: 12px;
	padding: 0px 10px;
	width: 100%;
	text-align: center;
	color: #fff;
	font-size: 20px;
	letter-spacing: 6px;
	margin-bottom: 10px;
	transition: all 100ms linear;
}

.login-text:focus {
	background-color: #fff;
	color: #3256A7;
	transform: scale(1.04);
}

.login-text::placeholder {
	color: rgba(255, 255, 255, 0.8);
	letter-spacing: 0;
}

.login-button {
	background-color: #fff;
	color: #3256A7;
	display: block;
	margin: 0px auto 0px auto;
	height: 40px;
	width: 120px;
	padding: 0px 20px;
	font-size: 16px;
	border-radius: 12px;
	margin-top: 10px;
	transition: all 100ms linear;
}

.login.is-loading .login-button,
.login-button:focus {
	transform: scale(1.04);
}

.login-button.is-invalid {
	opacity: 0.5;
	pointer-events: none;
}

.login-resend {
	display: block;
	text-align: center;
	color: rgba(255, 255, 255, 0.9);
	margin-top: 14px;
	font-size: 13px;
	cursor: pointer;
	text-decoration: underline;
}

.login-resend.is-disabled {
	opacity: 0.5;
	pointer-events: none;
	text-decoration: none;
}

.login-back {
	display: block;
	text-align: center;
	color: rgba(255, 255, 255, 0.8);
	margin-top: 8px;
	font-size: 13px;
	cursor: pointer;
}

</style>
